const sectionTemplate = { id: '', name: '', content: [''], fontSize: 1, fontFamily: '', fontWeight: '', fontStyle: '', textAlign: '', color: '', backgroundColor: '', padding: 0, gap: 0, enabled: true, showFieldLabels: false };

export function parsePrintSettings<T extends object>(text: string, template: T, pageSizes: string[]): T {
  if (text.length > 256 * 1024) throw new Error('Invalid settings file');
  const file = JSON.parse(text);
  if (file?.format !== 'stockflow-print-settings' || file.version !== 1) throw new Error('Unsupported settings file');
  const validate = (value: any, expected: any, key: string): void => {
    if (Array.isArray(expected)) {
      if (!Array.isArray(value) || value.length > 50) throw new Error('Invalid list');
      value.forEach(item => validate(item, key === 'labelSections' ? sectionTemplate : '', key === 'labelSections' ? 'section' : 'field'));
      if (key === 'labelSections' && new Set(value.map(item => item.id)).size !== value.length) throw new Error('Duplicate section');
    } else if (expected && typeof expected === 'object') {
      if (!value || Array.isArray(value) || typeof value !== 'object' || Object.keys(value).length !== Object.keys(expected).length) throw new Error('Invalid settings');
      Object.keys(expected).forEach(name => {
        if (!Object.prototype.hasOwnProperty.call(value, name)) throw new Error('Missing setting');
        validate(value[name], expected[name], name);
      });
    } else {
      if (typeof value !== typeof expected) throw new Error('Invalid type');
      if (typeof value === 'number') {
        const integer = ['count', 'numberOfCopies', 'columns', 'rows', 'offset'].includes(key);
        const positive = ['width', 'height', 'cellWidth', 'cellHeight', 'customPageWidth', 'customPageHeight', 'fontSize', 'count', 'numberOfCopies', 'columns', 'rows'].includes(key);
        if (!Number.isFinite(value) || value < 0 || value > (integer ? 10000 : 2000) || (integer && !Number.isInteger(value)) || (positive && value === 0)) throw new Error('Invalid number');
      }
      if (typeof value === 'string') {
        if (value.length > 120 || /[<>;{}\\\r\n]/.test(value)) throw new Error('Invalid text');
        if (key === 'pageSize' && !pageSizes.includes(value)) throw new Error('Invalid page size');
        if (['color', 'backgroundColor'].includes(key) && !/^(#[\da-f]{3}|#[\da-f]{6}|transparent)$/i.test(value)) throw new Error('Invalid color');
        if (key === 'fontFamily' && !['Arial', 'Times New Roman', 'Courier New', 'Georgia', 'Verdana', 'Helvetica', 'Trebuchet MS', 'Comic Sans MS'].includes(value)) throw new Error('Invalid font');
        if (key === 'fontWeight' && !/^(normal|bold|[1-9]00)$/.test(value)) throw new Error('Invalid weight');
        if (key === 'fontStyle' && !['normal', 'italic'].includes(value)) throw new Error('Invalid style');
        if (key === 'textAlign' && !['left', 'center', 'right'].includes(value)) throw new Error('Invalid alignment');
      }
    }
  };
  validate(file.settings, template, 'settings');
  return file.settings as T;
}

export function exportPrintSettings(settings: object) {
  return JSON.stringify({ format: 'stockflow-print-settings', version: 1, settings }, null, 2);
}
